import React, {useState, useRef, useEffect} from 'react';
import "./index.less"

const CityDropdown = ({OnSelect, cities, defaultSelect}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCity, setSelectedCity] = useState('选择城市');
    const dropdownRef = useRef(null);
    const cityItemContainerRef = useRef(null);
    const [selectedLocation, setSelectedLocation] = useState({province: '', city: '选择城市'});

    useEffect(() => {
        if (defaultSelect) {
            setSelectedLocation(defaultSelect);
        }
    }, [defaultSelect])

    useEffect(() => {
        if (isOpen) {
            // 下拉框打开时禁用fullPage.js的键盘和鼠标滚轮滚动
            window.fullpage_api.setKeyboardScrolling(false);
            window.fullpage_api.setMouseWheelScrolling(false);

            dropdownRef.current.classList.add('cityDropdown-open');

            if (cityItemContainerRef.current) {
                cityItemContainerRef.current.classList.add('cityItemContainer-open');
            }
        } else {
            // 下拉框关闭时重新启用fullPage.js的键盘和鼠标滚轮滚动
            window.fullpage_api.setKeyboardScrolling(true);
            window.fullpage_api.setMouseWheelScrolling(true);

            dropdownRef.current.classList.remove('cityDropdown-open');
            if (cityItemContainerRef.current) {
                cityItemContainerRef.current.classList.remove('cityItemContainer-open');
            }
        }

        console.log("ref", dropdownRef)
        console.log("ref2", cityItemContainerRef)
    }, [isOpen]);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleDropdownToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleCitySelect = (province, city) => {
        setSelectedLocation({province, city});
        setIsOpen(false);

        if (OnSelect) {
            OnSelect(province, city)
        }
    };

    return (
        <div className={"cityDropdown"} ref={dropdownRef}>
            <div onClick={handleDropdownToggle} style={{padding: '10px', paddingRight: "20px"}}>
                <span>{isOpen ? <>
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0 8.20709L4.78548 4.54957C5.50242 4.00161 6.4975 4.00161 7.21445 4.54956L12 8.20709L7.41418 2.20713L5.99996 0.792915L4.58575 2.20713L0 8.20709Z"
                            fill="white"/>
                    </svg>
                </> : <>
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0 0.792908L4.78548 4.45043C5.50242 4.99839 6.4975 4.99839 7.21445 4.45044L12 0.792908L7.41418 6.79287L5.99996 8.20708L4.58575 6.79287L0 0.792908Z"
                            fill="white"/>
                    </svg>
                </>} <span
                    style={{paddingLeft: "6px"}}>{selectedLocation.province ? `${selectedLocation.province}-${selectedLocation.city}` : selectedLocation.city}</span></span>
            </div>
            {isOpen && (
                <div className={"cityItemContainer"} ref={cityItemContainerRef}>
                    {Object.entries(cities).map(([province, cities]) => (
                        <div key={province}>
                            {/*<div className={"province"}>{province}</div>*/}
                            {cities.map((city) => (
                                <div className={"city"} key={city} onClick={() => handleCitySelect(province, city)}
                                     style={{padding: '5px', cursor: 'pointer'}}>
                                    {city}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CityDropdown;
